export default {
    cmrData: [],
    dashboardData: [],
    dashboardCmrTotals: 0,
    currentYear: new Date().getFullYear(),
    loading: false,
    cmrTotals: 0,
    userData: [],
    userTotals: 0,
    pdf: '',
    roles: [],
    rolesTotals: 0,
    organizations: [],
    organizationsTotals: 0,
    rowsPerPageItems: [5, 10, 15, 20, 50, 100],
    countries: [],
    loginUser: {},
    language: '',
    
    userOrganizations: {}
}